// extracted by mini-css-extract-plugin
export default {"language-button":"src-components-language-button-styles-language-button-fPNeZ"};